import React from "react";

export default function GoogleStyleLoader() {
  return (
    <div className='gloader'>
      <svg viewBox="0 0 150 33.2" width="180" height="150">
        <circle className="blue" cx="16.1" cy="16.6" r="16.1" fill="#527abd" />
        <circle className="red" cx="55.2" cy="16.6" r="16.1" fill="#de4431" />
        <circle className="yellow" cx="94.3" cy="16.6" r="16.1" fill="#f4b61a" />
        <circle className="green" cx="133.4" cy="16.6" r="16.1" fill="#009e52" />
      </svg>
    </div>
  );
}
